import React from "react";
import { Loader2, Send } from "lucide-react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { btnBrand, fmtBytes, fmtDate, docsLabel } from "@/components/accounting/ui";

const Line = ({ k, v, testId }) => (
  <div className="flex justify-between gap-4 py-2 border-b border-line/70 last:border-0 text-sm">
    <span className="text-faint">{k}</span><span className="text-ink font-medium text-right break-all" data-testid={testId}>{v}</span>
  </div>
);

export const SendConfirm = ({ target, settings, sending, onCancel, onConfirm }) => {
  if (!target) return null;
  const until = new Date(Date.now() + settings.link_days * 86400000).toISOString();
  const cc = settings.cc_enabled && settings.cc_email && settings.cc_email !== settings.advisor_email ? settings.cc_email : null;
  return (
    <AlertDialog open onOpenChange={(o) => !o && !sending && onCancel()}>
      <AlertDialogContent data-testid="acc-send-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Unterlagen jetzt an den Steuerberater senden?</AlertDialogTitle>
          <AlertDialogDescription>
            Der Empfänger erhält einen geschützten, zeitlich begrenzten Download-Link – keine Anhänge. Nach erfolgreichem Versand werden die enthaltenen Belege gesperrt.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <div className="rounded-lg border border-line px-4 py-1">
          <Line k="Empfänger" v={`${settings.advisor_name ? `${settings.advisor_name} · ` : ""}${settings.advisor_email}`} testId="acc-send-confirm-to" />
          {cc && <Line k="Kopie an" v={cc} testId="acc-send-confirm-cc" />}
          <Line k="Archiv" v={target.filename} />
          <Line k="Umfang" v={`${docsLabel(target.doc_count)} · ${fmtBytes(target.zip_size || target.total_size)}`} />
          <Line k="Link gültig bis" v={fmtDate(until)} />
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={sending} data-testid="acc-send-cancel-btn">Abbrechen</AlertDialogCancel>
          <button type="button" onClick={onConfirm} disabled={sending} className={btnBrand} data-testid="acc-send-confirm-btn">
            {sending ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />} Jetzt senden
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default SendConfirm;
